import React from 'react'

import { Skeleton, useMediaQueryContext, useSlider } from '@fourthwall/components'

import { Pills } from '../components/Pills'
import { Slider } from '../components/Slider'
import { useHomeProducts } from '../useHomeProducts'
import * as S from './styled'

export const OnboardingProductsSlider = () => {
  const mediaQuery = useMediaQueryContext()
  const homeProducts = useHomeProducts()
  const slider = useSlider()

  if (!homeProducts || homeProducts?.isLoading) {
    return <SkeletonComponent />
  }

  if (!homeProducts) {
    return null
  }

  return (
    <S.SliderContainer {...slider.getContainerProps()}>
      {homeProducts.categories && homeProducts.categories.visible && mediaQuery.tablet && (
        <S.SliderHeader>
          <Pills>
            {homeProducts.categories.options.map((option) => {
              return (
                <Pills.Pill
                  key={option.value}
                  active={option.value === homeProducts.categories.value}
                  label={option.label}
                  onClick={() => homeProducts?.categories.onChange(option.value)}
                />
              )
            })}
          </Pills>
        </S.SliderHeader>
      )}

      <Slider
        products={homeProducts.products}
        slider={slider}
        onProductClick={homeProducts.onProductClick}
        activeCategory={homeProducts.activeCategory}
      />
    </S.SliderContainer>
  )
}

export const SkeletonComponent = () => {
  const mediaQuery = useMediaQueryContext()

  const skeletonCount = (() => {
    if (mediaQuery.tablet) return 5

    return 2
  })()

  return (
    <S.SkeletonSlider>
      {[...Array(skeletonCount)].map((_, index) => (
        <S.SkeletonCard key={index}>
          <S.SkeletonProductImage />
          <S.SkeletonProductInfo>
            <Skeleton.Shape height={20} width="80%" />
            <Skeleton.Shape height={16} width="40%" />
          </S.SkeletonProductInfo>
        </S.SkeletonCard>
      ))}
    </S.SkeletonSlider>
  )
}
